import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { Menu } from "lucide-react";
import { useState } from "react";
import { Sidebar } from "@/components/layout";
import { getCustomerInfo, getSession, signOut } from "@/data/auth";

export const Route = createFileRoute("/_authenticated")({
	beforeLoad: async () => {
		const session = await getSession();
		if (!session) {
			throw redirect({ to: "/login" });
		}
		const customer = await getCustomerInfo();
		return { session, customer };
	},
	component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
	const { session, customer } = Route.useRouteContext();
	const [sidebarOpen, setSidebarOpen] = useState(false);

	const user = session?.user
		? {
				name: session.user.name || "User",
				email: session.user.email || "",
				initials: getInitials(session.user.name || session.user.email || "U"),
			}
		: null;

	const handleSignOut = async () => {
		await signOut();
	};

	return (
		<div className="flex min-h-screen bg-bg-primary">
			{/* Mobile header */}
			<header className="fixed top-0 right-0 left-0 z-20 flex h-14 items-center border-border border-b bg-bg-secondary px-4 lg:hidden">
				<button
					type="button"
					onClick={() => setSidebarOpen(true)}
					className="rounded-lg p-2 text-text-secondary hover:bg-bg-hover hover:text-text-primary"
				>
					<Menu className="h-5 w-5" />
				</button>
				<span className="ml-3 font-semibold text-sm text-text-primary">
					{customer?.name || "Customer Portal"}
				</span>
			</header>

			<Sidebar
				user={user}
				customerName={customer?.name}
				customerLogo={customer?.logoUrl}
				isOpen={sidebarOpen}
				onClose={() => setSidebarOpen(false)}
				onSignOut={handleSignOut}
			/>

			{/* Main content - add top padding on mobile for header */}
			<main className="flex-1 p-6 pt-20 lg:ml-64 lg:pt-6">
				<Outlet />
			</main>
		</div>
	);
}

function getInitials(name: string): string {
	return name
		.split(" ")
		.map((n) => n[0])
		.join("")
		.toUpperCase()
		.slice(0, 2);
}
